import './funcs';
import Timer from '../helpers/Timer';
import Lot from './Lot';

class Updater {
    static init() {
        setInterval(() => {
            this.request()
        }, 3000);
    }

    static request() {
        $.ajax({
            type: 'POST',
            url: '/api/updater/check',
            data: {
                lots: Object.keys(window.LOTS),
                last_update: window.lastUpdate
            },
            success: r => {
                Lot.update(r.lots);
                Lot.create(r.newLots);

                var to_delete = [];
                for (var id in window.LOTS)
                    if (typeof r.lots[id] == 'undefined')
                        to_delete.push(id);

                Lot.delete(to_delete);

                if (r.timestamp)
                    Timer.update(r.timestamp);
            },
            error: e => {
                var r = e.responseJSON;
            }
        });
    }

    static requestLot(lotID, pingChanges) {
        $.ajax({
            type: 'post',
            url: '/api/updater/lot',
            data: {
                lot_id: lotID
            },
            success: r => {
                Updater.updateLot(r, pingChanges);
            },
            error: e => {
                var r = e.responseJSON;
                console.log(r);
            }
        });
    }

    static showNewLotsCounter(count) {
        if (count == 0)
            return;

        $('#new-lots-counter').text(
            wordEnding(count, ['Появился ', 'Появилось ', 'Появилось ']) +
            count +
            wordEnding(count, [' новый ', ' новых ', ' новых ']) +
            wordEnding(count, [' лот ', ' лота ', ' лота '])
        );
        $('#new-lots-counter').addClass('active');
    }

    static updateCurrentLots(lots) {
        for (var id in window.LOTS) {
            if (window.LOTS[id].price != lots[id].price)
                Updater.updatePrice(id, lots[id].price);
            if (window.LOTS[id].status != lots[id].status)
                Updater.updateStatus(lots[id]);
            if (window.LOTS[id].winner != lots[id].winner)
                Updater.updateWinner(id, lots[id].winner);
        }
    }

    static updateLot(data, pingChanges) {
        var id = data.lot.lot_id;
        var changed = false;

        if (window.LOTS[id].price != data.lot.price) {
            Updater.updatePrice(id, data.lot.price);
            changed = true;
        }
        if (window.LOTS[id].status != data.lot.status) {
            Updater.updateStatus(data.lot);
            changed = true;
        }
        if (window.LOTS[id].winner != data.lot.winner) {
            Updater.updateWinner(id, data.lot.winner);
            changed = true;
        }
        if (data.lot.status == 26 && data.lot.dt_end && window.LOTS[id].dt_end != data.lot.dt_end) {
            window.LOTS[id].dt_end = data.lot.dt_end;
            Updater.updateTimer(id, data.lot.dt_end);
            changed = true;
        }
        if (data.lot.status == 25 && data.lot.dt_start && window.LOTS[id].dt_start != data.lot.dt_start) {
            window.LOTS[id].dt_start = data.lot.dt_start;
            Updater.updateTimer(id, data.lot.dt_start);
            changed = true;
        }

        if (pingChanges && ! changed && Updater.checkChangesLimit(id))
            setTimeout(Updater.requestLot, 1000, id, true);
    }

    static checkChangesLimit(id) {
        window.changesLimit = window.changesLimit || {};
        window.changesLimit[id] = window.changesLimit[id] || 10;

        if (window.changesLimit[id] === 0)
            return false;

        window.changesLimit[id]--;
        return true;
    }

    static updatePrice(id, price) {
        $(`[data-bid][data-lot="${id}"]`).find('[data-bid-price]').text(price.format() + ' руб.');
        $(`[data-bid][data-lot="${id}"]`).find('[data-bid-next-value]').text((parseInt(price) + window.LOTS[id].step).format());
        window.LOTS[id].price = price;
    }

    static updateStatus(lot) {
        var html = null;
        var html2 = null;
        var timer = false

        switch (lot.status) {
            case 26:
                if ($('[data-bid][data-lot="' + lot.lot_id + '"]').find('.sub-header__item').length) {
                    html = '<div class="sub-header__line">' +
                                '<p class="auction-timer__wrapper auction-timer__wrapper_user">До конца аукциона: <span class="auction-timer auction-timer_user" data-end="' + lot.dt_end + '"></span></p>' +
                            '</div>' +
                            '<div class="sub-header__line no-fix">'+
                                '<p>Начальная цена ' + lot.price_start.format() + ' руб.</p>' +
                            '</div>' +
                            '<div class="sub-header__line no-fix">' +
                                '<div class="bid-status bid-status_none" data-bid-status>' +
                                    '<div class="bid-status__caption"></div>' +
                                '</div>' +
                            '</div>';
                    html2 = '<div class="sub-header__item no-fix">' +
                            '<table>' +
                                '<tbody>' +
                                    '<tr>' +
                                        '<td>Текущая цена </td>' +
                                        '<td align="right" class="current-price" data-bid-price="">' + lot.price.format() + ' руб.</td>' +
                                    '</tr>' +
                                    '<tr>' +
                                        '<td>Шаг аукциона </td>' +
                                        '<td align="right">' + lot.step.format() + ' руб.</td>' +
                                    '</tr>' +
                                '</tbody>' +
                            '</table>' +
                            '<div class="card__bid">' +
                                '<div class="card__bid-minus" data-bid-minus=""></div>' +
                                '<input class="filter__input number card__bid-value" type="text" name="bid" placeholder="Ваша ставка" value="" data-bid-value="">' +
                                '<div class="card__bid-plus" data-bid-plus=""></div>' +
                            '</div>' +
                            '<button class="card__button button button_wide button_full bid-lot" data-bid-make="">' +
                                '<span class="button__caption">Сделать ставку</span>' +
                            '</button>';
                } else {
                    html = '<div class="card__main-item__info">' +
                                '<table>' +
                                    '<tbody>' +
                                        '<tr>' +
                                            '<td>Начальная цена </td>' +
                                            '<td align="right">' + lot.price_start.format() + ' руб.</td>' +
                                        '</tr>' +
                                        '<tr>' +
                                            '<td colspan="2">' +
                                                '<div class="bid-status bid-status_none" data-bid-status="">' +
                                                '<div class="bid-status__caption"></div>' +
                                            '</div>' +
                                            '</td>' +
                                        '</tr>' +
                                        '<tr>' +
                                            '<td>Текущая цена </td>' +
                                            '<td align="right" class="current-price" data-bid-price="">' + lot.price.format() + ' руб.</td>' +
                                        '</tr>' +
                                        '<tr>' +
                                            '<td>Шаг аукциона </td>' +
                                            '<td align="right">' + lot.step.format() + ' руб.</td>' +
                                        '</tr>' +
                                    '</tbody>' +
                                '</table>' +
                            '</div>' +
                            '<div class="card__main-item__bet">' +
                                '<p class="auction-timer__wrapper auction-timer__wrapper_user">До конца аукциона: <span class="auction-timer auction-timer_user" data-end="' + lot.dt_end + '"></span></p>' +
                                '<div class="card__bid">' +
                                    '<div class="card__bid-minus" data-bid-minus=""></div>' +
                                    '<input class="filter__input number card__bid-value" type="text" name="bid" placeholder="Ваша ставка" value="" data-bid-value="">' +
                                    '<div class="card__bid-plus" data-bid-plus=""></div>' +
                                '</div>' +
                                '<button class="card__button button button_wide button_full bid-lot" data-bid-make="">' +
                                    '<span class="button__caption">Сделать ставку</span>' +
                                '</button>' +
                            '</div>';
                }
                timer = true;
                break;
            case 27:
            case 28:
            case 29:
                html = '<div class="card__main-item__bet"><div class="auction-timer_done"><p>Аукцион окончен</p></div></div>';
                break;
        }

        if (html) {
            if ($('[data-bid][data-lot="' + lot.lot_id + '"]').find('.sub-header__item').length) {
                $('[data-bid][data-lot="' + lot.lot_id + '"]').find('.sub-header__item.no-fix').remove();
                $('[data-bid][data-lot="' + lot.lot_id + '"]').find('.sub-header__item').html(html);
                if (html2) {
                    $('[data-bid][data-lot="' + lot.lot_id + '"]').find('.sub-header__item').after(html2);
                }
            } else {
                $('[data-bid][data-lot="' + lot.lot_id + '"]').find('.card__main-item:nth-child(2)').html(html);
            }
            if (lot.status == 26) {
                $(document).find('input.number').number(true, 0, ',', ' ');
                $('[data-bid][data-lot="' + lot.lot_id + '"]').find('.card__main').removeClass('card__main--col');
            } else {
                $('[data-bid][data-lot="' + lot.lot_id + '"]').find('.card__main').addClass('card__main--col');
            }
        }
        if (timer)
            Updater.updateTimer(lot.lot_id, lot.dt_end);

        if (typeof window.LOTS[lot.lot_id] != 'undefined')
            window.LOTS[lot.lot_id].status = lot.status;
    }

    static updateWinner(id, winner) {
        var elem = $('[data-bid][data-lot="' + id + '"]').find('[data-bid-status]');
        if (winner === null) {
            elem.removeClass('bid-status_lead');
            elem.removeClass('bid-status_beaten');
            elem.addClass('bid-status_none');
            elem.children().text('');
        } else if (winner === true) {
            elem.removeClass('bid-status_none');
            elem.removeClass('bid-status_beaten');
            elem.addClass('bid-status_lead');
            elem.children().text('Вы лидируете');
        } else if (winner === false) {
            elem.removeClass('bid-status_none');
            elem.removeClass('bid-status_lead');
            elem.addClass('bid-status_beaten');
            elem.children().text('Ваша ставка перебита');
        }

        window.LOTS[id].winner = winner;
    }

    static updateTimer(id, time) {
        let timerObj = $('[data-bid][data-lot="' + id + '"]').find('.auction-timer');
        Timer.init(timerObj, Timer.getTimestamp(time));
    }
}

export default Updater;